module.exports = __webpack_public_path__ + "img/nodejs.64a7ffd2.png";